import React from "react";
import { useSelector } from "react-redux";

import { getReviewCount, getRoundedRating } from "redux/selectors/dispensary";

import StarRating from "components/botanic/StarRating";

const ReviewRating = ({
  className,
  totalReviews,
  slug,
}: {
  className?: string;
  totalReviews?: number;
  slug?: string;
}) => {
  const averageRating = useSelector(getRoundedRating);
  const totalReviewCount = useSelector(getReviewCount);

  return totalReviewCount > 0 ? (
    slug ? (
      <StarRating
        rating={averageRating}
        starWidth={12}
        className="text-xs"
        ratingCount={totalReviews}
        starLink={`/dispensary-info/${slug}/reviews`}
      />
    ) : (
      <div className={className}>
        <StarRating
          rating={averageRating}
          starWidth={12}
          className="text-xs"
          starLink="#reviews-overview"
          ratingCountClass="underline"
          ratingCount={totalReviewCount}
          showReviewsText={true}
        />
      </div>
    )
  ) : (
    <></>
  );
};

export default ReviewRating;
